import W from "./assets/mixins/emitter.js";
import X from "./assets/mixins/focus.js";
import { ElInput as J } from "element-plus";
import { S as Y } from "./scrollbar2-f7c66394.js";
import Z from "./assets/utils/vue-popper.js";
import $ from "./assets/mixins/event.js";
import { openBlock as c, createElementBlock as I, normalizeClass as O, normalizeStyle as k, renderSlot as C, withDirectives as g, withModifiers as y, createElementVNode as z, toDisplayString as A, vShow as x, resolveComponent as v, resolveDirective as ee, createVNode as T, withKeys as _, createSlots as te, withCtx as b, createBlock as E, createCommentVNode as D, Transition as ie, Fragment as se } from "vue";
import { _ as F } from "./_plugin-vue_export-helper-dad06003.js";
import le from "./virtual-list/index.js";
import { g as d, e as re, a as ne, b as oe, v as V } from "./util-b2b0dc25.js";
import { I as ae } from "./icon-51ff7679.js";
import { g as he } from "./_commonjsHelpers-ce4d82cc.js";
import { _ as ue, i as ce } from "./isSymbol-62c14278.js";
import { t as de } from "./toNumber-ea93c45b.js";
import pe from "./assets/utils/clickoutside.js";
import fe from "./assets/utils/scroll-into-view.js";
import me from "./select/src/navigation-mixin.js";
import { isKorean as ve } from "./assets/utils/shared.js";
const be = {
  name: "rSelectDropdown",
  componentName: "rSelectDropdown",
  mixins: [Z, $],
  inject: ["observeUpdatePopper", "observeDestroyPopper"],
  props: {
    placement: {
      default: "bottom-start"
    },
    boundariesPadding: {
      default: 0
    },
    popperOptions: {
      default() {
        return {
          gpuAcceleration: !1
        };
      }
    },
    visibleArrow: {
      default: !0
    },
    appendToBody: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      minWidth: ""
    };
  },
  computed: {
    popperClass() {
      return this.$parent.popperClass;
    }
  },
  watch: {
    "$parent.inputWidth"() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + "px";
    }
  },
  mounted() {
    this.referenceElm = this.$parent.$parent.$refs.reference.$el, this.$parent.popperElm = this.popperElm = this.$el, this.eventOn("COMP_SELECT_DROPDOWN_UpdatePopper", () => {
      this.$parent.visible && this.updatePopper();
    }), this.eventOn("COMP_SELECT_DROPDOWN_DestroyPopper", this.destroyPopper);
  }
};
function ge(e, t, i, r, l, s) {
  return c(), I(
    "div",
    {
      class: O(["el-select-dropdown el-popper r-select-el-select-dropdown", [{ "is-multiple": e.$parent.multiple }, s.popperClass]]),
      style: k({ minWidth: l.minWidth })
    },
    [
      C(e.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
const ye = /* @__PURE__ */ F(be, [["render", ge], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/select/src/select-dropdown.vue"]]), Oe = {
  mixins: [W, $],
  name: "rOption",
  componentName: "rOption",
  inject: ["select", "observeQueryChange"],
  props: {
    value: {
      required: !0
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: !1
    },
    filterValue: {}
  },
  data() {
    return {
      index: -1,
      groupDisabled: !1,
      visible: !0,
      hitState: !1,
      hover: !1
    };
  },
  computed: {
    isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === "[object object]";
    },
    currentLabel() {
      return this.label || (this.isObject ? "" : this.value);
    },
    currentValue() {
      return this.value || this.label || "";
    },
    itemSelected() {
      return this.select.multiple ? this.contains(this.select.value, this.value) : this.isEqual(this.value, this.select.value);
    },
    limitReached() {
      return this.select.multiple ? !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0 : !1;
    }
  },
  watch: {
    currentLabel() {
      !this.created && !this.select.remote && this.select.setSelected();
    },
    value(e, t) {
      const { remote: i, valueKey: r } = this.select;
      if (!this.created && !i) {
        if (r && typeof e == "object" && typeof t == "object" && e[r] === t[r])
          return;
        this.select.setSelected();
      }
    }
  },
  methods: {
    isEqual(e, t) {
      if (this.isObject) {
        const i = this.select.valueKey;
        return d(e, i) === d(t, i);
      } else
        return e === t;
    },
    contains(e = [], t) {
      if (this.isObject) {
        const i = this.select.valueKey;
        return e && e.some((r) => d(r, i) === d(t, i));
      } else
        return e && e.indexOf(t) > -1;
    },
    handleGroupDisabled(e) {
      this.groupDisabled = e;
    },
    hoverItem() {
      !this.disabled && !this.groupDisabled && (this.select.hoverIndex = this.select.options.indexOf(this));
    },
    selectOptionClick() {
      this.disabled !== !0 && this.groupDisabled !== !0 && this.select.handleOptionSelect(this, !0);
    },
    queryChange(e) {
      this.visible = new RegExp(re(e), "i").test(this.currentLabel) || this.created, this.select.filterOptionMethod && (this.visible = this.select.filterOptionMethod(e, this.filterValue || this.value)), this.visible || this.select.filteredOptionsCount--;
    }
  },
  created() {
    this.select.options.push(this), this.select.cachedOptions.push(this), this.select.optionsCount++, this.select.filteredOptionsCount++, this.eventOn("COMP_SELECT_OPTION_QueryChange", this.queryChange);
  },
  beforeDestroy() {
    const { selected: e, multiple: t } = this.select, i = t ? e : [e], r = this.select.cachedOptions.indexOf(this), l = i.indexOf(this);
    r > -1 && l < 0 && this.select.cachedOptions.splice(r, 1), this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};
function Ce(e, t, i, r, l, s) {
  return g((c(), I(
    "li",
    {
      onMouseenter: t[0] || (t[0] = (...o) => s.hoverItem && s.hoverItem(...o)),
      onClick: t[1] || (t[1] = y((...o) => s.selectOptionClick && s.selectOptionClick(...o), ["stop"])),
      class: O(["el-select-dropdown__item", {
        selected: s.itemSelected,
        "is-disabled": i.disabled || l.groupDisabled || s.limitReached,
        hover: l.hover
      }])
    },
    [
      C(e.$slots, "default", {}, () => [
        z(
          "span",
          null,
          A(s.currentLabel),
          1
          /* TEXT */
        )
      ])
    ],
    34
    /* CLASS, HYDRATE_EVENTS */
  )), [
    [x, l.visible]
  ]);
}
const Se = /* @__PURE__ */ F(Oe, [["render", Ce], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/select/src/option.vue"]]);
var Le = ue, _e = function() {
  return Le.Date.now();
}, xe = _e, Ie = ce, B = xe, q = de, we = "Expected a function", Pe = Math.max, Te = Math.min;
function Ee(e, t, i) {
  var r, l, s, o, a, u, p = 0, w = !1, m = !1, S = !0;
  if (typeof e != "function")
    throw new TypeError(we);
  t = q(t) || 0, Ie(i) && (w = !!i.leading, m = "maxWait" in i, s = m ? Pe(q(i.maxWait) || 0, t) : s, S = "trailing" in i ? !!i.trailing : S);
  function h(n) {
    var f = r, L = l;
    return r = l = void 0, p = n, o = e.apply(L, f), o;
  }
  function Q(n) {
    return p = n, a = setTimeout(P, t), w ? h(n) : o;
  }
  function K(n) {
    var f = n - u, L = n - p, j = t - f;
    return m ? Te(j, s - L) : j;
  }
  function N(n) {
    var f = n - u, L = n - p;
    return u === void 0 || f >= t || f < 0 || m && L >= s;
  }
  function P() {
    var n = B();
    if (N(n))
      return H(n);
    a = setTimeout(P, K(n));
  }
  function H(n) {
    return a = void 0, S && r ? h(n) : (r = l = void 0, o);
  }
  function U() {
    a !== void 0 && clearTimeout(a), p = 0, r = u = l = a = void 0;
  }
  function G() {
    return a === void 0 ? o : H(B());
  }
  function M() {
    var n = B(), f = N(n);
    if (r = arguments, l = this, u = n, f) {
      if (a === void 0)
        return Q(u);
      if (m)
        return clearTimeout(a), a = setTimeout(P, t), h(u);
    }
    return a === void 0 && (a = setTimeout(P, t)), o;
  }
  return M.cancel = U, M.flush = G, M;
}
var Me = Ee;
const R = /* @__PURE__ */ he(Me), De = {
  mixins: [W, X("reference"), me, $],
  name: "rSelect",
  componentName: "rSelect",
  components: {
    ElInput: J,
    SelectMenu: ye,
    Option: Se,
    Scrollbar2: Y,
    RIcon: ae,
    VirtualList: le
  },
  directives: { Clickoutside: pe },
  props: {
    name: String,
    id: String,
    width: String,
    type: { type: String, default: "input" },
    value: {
      required: !0
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator(e) {
        return process.env.NODE_ENV !== "production" && console.warn(
          "[Element Warn][Select]'auto-complete' property will be deprecated in next major version. please use 'autocomplete' instead."
        ), !0;
      }
    },
    automaticDropdown: Boolean,
    size: {
      type: String,
      default: "default"
    },
    noReadonly: {
      type: Boolean,
      default: !1
    },
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    filterOptionMethod: Function,
    lazyLoad: Boolean,
    multiple: Boolean,
    // 暂不支持 :)
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      required: !1
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: "value"
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: !0
    },
    /**
     * 虚拟列表数据，启用虚拟列表的必要条件，否则降级为普通列表
     */
    virtualListData: {
      type: Array,
      default: () => []
    },
    /**
     * 虚拟列表每项高度，启用虚拟列表的必要条件，否则降级为普通列表
     */
    virtualListItemHeight: {
      type: [Number, String],
      default: 0
    },
    /**
     * 虚拟列表可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    virtualListWrapperHeight: {
      type: [Number, String],
      default: 324
    },
    /**
     * 虚拟列表class，用来设置虚拟列表最大可视区域的高度，最大高度默认为max-height:274px
     */
    virtualListWrapperClass: {
      type: String,
      default: ""
    },
    /**
     * 虚拟列表将依据此属性指定data中某个字段作为key，同列表key，用来帮助vue在diff中的原地复用，默认采用索引
     */
    virtualListkeyStr: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: !1,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: "",
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: !1,
      softFocus: !1,
      selectedLabel: "",
      hoverIndex: -1,
      query: "",
      previousQuery: null,
      inputHovering: !1,
      currentPlaceholder: "",
      menuVisibleOnFocus: !1,
      isOnComposition: !1,
      isSilentBlur: !1,
      showLoadMoreBar: !1
    };
  },
  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },
  provide() {
    return {
      select: this,
      observeQueryChange: this.observeQueryChange,
      observeUpdatePopper: this.observeUpdatePopper,
      observeDestroyPopper: this.observeDestroyPopper
    };
  },
  computed: {
    // 是否虚拟列表模式
    isVirtualListMode() {
      return this.virtualListData.length > 0 && this.virtualListItemHeight;
    },
    filtedVirtualListData() {
      return this.virtualListData.filter((e) => this.filterMethod ? this.filterMethod(e) : e.name.includes(this.selectedLabel || ""));
    },
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly() {
      return this.noReadonly ? !1 : !this.filterable || this.multiple || !ne() && !oe() && !this.visible;
    },
    showClose() {
      const e = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== void 0 && this.value !== null && this.value !== "";
      return this.clearable && !this.selectDisabled && this.inputHovering && e;
    },
    iconClass() {
      return this.remote && this.filterable || this.visible ? "" : " is-reverse";
    },
    debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText() {
      return this.loading ? this.loadingText || this.$t("bmui-select.loading") : this.remote && this.query === "" && this.options.length === 0 ? !1 : this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0 ? this.noMatchText || this.$t("bmui-select.noMatch") : this.options.length === 0 ? this.noDataText || this.$t("bmui-select.noData") : null;
    },
    showNewOption() {
      const e = this.options.filter((t) => !t.created).some((t) => t.currentLabel === this.query);
      return this.filterable && this.allowCreate && this.query !== "" && !e;
    },
    selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize() {
      return ["small", "mini"].indexOf(this.selectSize) > -1 ? "mini" : "small";
    },
    propPlaceholder() {
      return typeof this.placeholder != "undefined" ? this.placeholder : this.$t("bmui-select.placeholder");
    }
  },
  watch: {
    selectDisabled() {
      this.$nextTick(() => {
        this.resetInputHeight();
      });
    },
    propPlaceholder(e) {
      this.cachedPlaceHolder = this.currentPlaceholder = e;
    },
    value(e, t) {
      this.multiple && (this.resetInputHeight(), e && e.length > 0 || this.$refs.input && this.query !== "" ? this.currentPlaceholder = "" : this.currentPlaceholder = this.cachedPlaceHolder, this.filterable && !this.reserveKeyword && (this.query = "", this.handleQueryChange(this.query))), this.setSelected(), this.filterable && !this.multiple && (this.inputLength = 20), V(e, t) || this.dispatch("ElFormItem", "el.form.change", e);
    },
    visible(e) {
      var t, i;
      e ? ((t = this.$refs.VirtualListRef) == null || t.initState(), this.eventEmit("COMP_SELECT_DROPDOWN_UpdatePopper"), this.filterable && (this.query = this.remote ? "" : this.selectedLabel, this.handleQueryChange(this.query), this.multiple ? this.$refs.input.focus() : (this.remote || this.eventEmit("COMP_SELECT_OPTION_QueryChange", ""), this.selectedLabel && (this.currentPlaceholder = this.selectedLabel, this.selectedLabel = ""))), (i = this.$refs.scrollbar) != null && i.$refs.wrap && this.bindObserve(
        this.$refs.loadMoreBar,
        this.$refs.scrollbar.$refs.wrap
      )) : (this.unBindObserve(this.$refs.loadMoreBar), this.eventEmit("COMP_SELECT_DROPDOWN_DestroyPopper"), this.$refs.input && this.$refs.input.blur(), this.query = "", this.previousQuery = null, this.selectedLabel = "", this.inputLength = 20, this.menuVisibleOnFocus = !1, this.resetHoverIndex(), this.$nextTick(() => {
        this.$refs.input && this.$refs.input.value === "" && this.selected.length === 0 && (this.currentPlaceholder = this.cachedPlaceHolder);
      }), this.multiple || (this.selected && (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel ? this.selectedLabel = this.createdLabel : this.selectedLabel = this.selected.currentLabel, this.filterable && (this.query = this.selectedLabel, this.handleQueryChange(""))), this.filterable && (this.currentPlaceholder = this.cachedPlaceHolder))), this.$emit("visible-change", e), this.dispatch("rCoinSelector", "menuChange", [this.visible]);
    },
    options() {
      if (this.$isServer)
        return;
      this.$nextTick(() => {
        this.eventEmit("COMP_SELECT_DROPDOWN_UpdatePopper");
      }), this.multiple && this.resetInputHeight();
      const e = this.$el.querySelectorAll("input");
      [].indexOf.call(e, document.activeElement) === -1 && this.setSelected(), this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount && this.checkDefaultFirstOption();
    }
  },
  methods: {
    bindObserve(e, t) {
      this.io = new IntersectionObserver(
        (i) => {
          i && i.length && i[0].isIntersecting && this.$emit("reach-bottom");
        },
        {
          root: t
        }
      ), this.io.observe(e);
    },
    unBindObserve(e) {
      var t;
      e = e || this.$refs.loadMoreBar, (t = this.io) == null || t.unobserve(e);
    },
    loadFinished() {
      this.showLoadMoreBar = !1;
    },
    handleNavigate(e) {
      this.isOnComposition || this.navigateOptions(e);
    },
    handleComposition(e) {
      const t = e.target.value;
      if (e.type === "compositionend")
        this.isOnComposition = !1, this.$nextTick((i) => this.handleQueryChange(t));
      else {
        const i = t[t.length - 1] || "";
        this.isOnComposition = !ve(i);
      }
    },
    handleQueryChange(e) {
      if (!(this.previousQuery === e || this.isOnComposition)) {
        if (this.previousQuery === null && (typeof this.filterMethod == "function" || typeof this.remoteMethod == "function")) {
          this.previousQuery = e;
          return;
        }
        this.previousQuery = e, this.$nextTick(() => {
          this.visible && this.eventEmit("COMP_SELECT_DROPDOWN_UpdatePopper");
        }), this.hoverIndex = -1, this.multiple && this.filterable && this.$nextTick(() => {
          const t = this.$refs.input.value.length * 15 + 20;
          this.inputLength = this.collapseTags ? Math.min(50, t) : t, this.managePlaceholder(), this.resetInputHeight();
        }), this.remote && typeof this.remoteMethod == "function" ? (this.hoverIndex = -1, this.remoteMethod(e)) : typeof this.filterOptionMethod == "function" ? (this.filteredOptionsCount = this.optionsCount, this.eventEmit("COMP_SELECT_OPTION_QueryChange", e)) : typeof this.filterMethod == "function" ? this.filterMethod(e) : (this.filteredOptionsCount = this.optionsCount, this.eventEmit("COMP_SELECT_OPTION_QueryChange", e)), this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount && this.checkDefaultFirstOption();
      }
    },
    scrollToOption(e) {
      const t = Array.isArray(e) && e[0] ? e[0].$el : e.$el;
      if (this.$refs.popper && t) {
        const i = this.$refs.popper.$el.querySelector(
          ".el-select-dropdown__wrap"
        );
        fe(i, t);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter() {
      this.$nextTick(() => this.scrollToOption(this.selected));
    },
    emitChange(e) {
      V(this.value, e) || this.$emit("change", e);
    },
    getOption(e) {
      let t;
      const i = Object.prototype.toString.call(e).toLowerCase() === "[object object]", r = Object.prototype.toString.call(e).toLowerCase() === "[object null]", l = Object.prototype.toString.call(e).toLowerCase() === "[object undefined]";
      for (let a = this.cachedOptions.length - 1; a >= 0; a--) {
        const u = this.cachedOptions[a];
        if (i ? d(u.value, this.valueKey) === d(e, this.valueKey) : u.value === e) {
          t = u;
          break;
        }
      }
      if (t)
        return t;
      const s = !i && !r && !l ? String(e) : "", o = {
        value: e,
        currentLabel: s
      };
      return this.multiple && (o.hitState = !1), o;
    },
    setSelected() {
      if (!this.multiple) {
        const t = this.getOption(this.value);
        t.created ? (this.createdLabel = t.currentLabel, this.createdSelected = !0) : this.createdSelected = !1, (this.isVirtualListMode && t.currentLabel && !this.visible || !this.isVirtualListMode) && (this.selectedLabel = t.currentLabel, this.selected = t);
        return;
      }
      const e = [];
      Array.isArray(this.value) && this.value.forEach((t) => {
        e.push(this.getOption(t));
      }), this.selected = e, this.$nextTick(() => {
        this.resetInputHeight();
      });
    },
    handleFocus(e) {
      this.softFocus ? this.softFocus = !1 : ((this.automaticDropdown || this.filterable) && (this.filterable && !this.visible && (this.menuVisibleOnFocus = !0), this.visible = !0), this.$emit("focus", e));
    },
    blur() {
      this.visible = !1, this.$refs.reference.blur();
    },
    handleBlur(e) {
      setTimeout(() => {
        this.isSilentBlur ? this.isSilentBlur = !1 : this.$emit("blur", e);
      }, 50), this.softFocus = !1;
    },
    handleClearClick(e) {
      this.deleteSelected(e);
    },
    doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose() {
      this.visible = !1;
    },
    toggleLastOptionHitState(e) {
      if (!Array.isArray(this.selected))
        return;
      const t = this.selected[this.selected.length - 1];
      if (t)
        return e === !0 || e === !1 ? (t.hitState = e, e) : (t.hitState = !t.hitState, t.hitState);
    },
    deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        const t = this.value.slice();
        t.pop(), this.$emit("input", t), this.emitChange(t);
      }
    },
    managePlaceholder() {
      this.currentPlaceholder !== "" && (this.currentPlaceholder = this.$refs.input.value ? "" : this.cachedPlaceHolder);
    },
    resetInputState(e) {
      e.keyCode !== 8 && this.toggleLastOptionHitState(!1), this.inputLength = this.$refs.input.value.length * 15 + 20, this.resetInputHeight();
    },
    resetInputHeight() {
      this.collapseTags && !this.filterable || this.$nextTick(() => {
        if (!this.$refs.reference)
          return;
        const e = this.$refs.reference.$el.childNodes, t = [].filter.call(
          e,
          (s) => s.tagName === "INPUT"
        )[0], i = this.$refs.tags, r = i ? Math.round(i.getBoundingClientRect().height) : 0, l = this.initialInputHeight || 40;
        t.style.height = this.selected.length === 0 ? l + "px" : Math.max(
          i ? r + (r > l ? 6 : 0) : 0,
          l
        ) + "px", this.visible && this.emptyText !== !1 && this.broadcast("rSelectDropdown", "updatePopper");
      });
    },
    resetHoverIndex() {
      setTimeout(() => {
        this.multiple ? this.selected.length > 0 ? this.hoverIndex = Math.min.apply(
          null,
          this.selected.map((e) => this.options.indexOf(e))
        ) : this.hoverIndex = -1 : this.hoverIndex = this.options.indexOf(this.selected);
      }, 300);
    },
    handleOptionSelect(e, t) {
      if (this.multiple) {
        const i = (this.value || []).slice(), r = this.getValueIndex(i, e.value);
        r > -1 ? i.splice(r, 1) : (this.multipleLimit <= 0 || i.length < this.multipleLimit) && i.push(e.value), this.$emit("input", i), this.emitChange(i), e.created && (this.query = "", this.handleQueryChange(""), this.inputLength = 20), this.filterable && this.$refs.input.focus();
      } else
        this.$emit("input", e.value), this.emitChange(e.value), this.visible = !1;
      this.isSilentBlur = t, this.setSoftFocus(), !this.visible && this.$nextTick(() => {
        this.scrollToOption(e);
      });
    },
    setSoftFocus() {
      this.softFocus = !0;
      const e = this.$refs.input || this.$refs.reference;
      e && e.focus();
    },
    getValueIndex(e = [], t) {
      if (Object.prototype.toString.call(t).toLowerCase() === "[object object]") {
        const r = this.valueKey;
        let l = -1;
        return e.some((s, o) => d(s, r) === d(t, r) ? (l = o, !0) : !1), l;
      } else
        return e.indexOf(t);
    },
    toggleMenu() {
      this.selectDisabled || (this.menuVisibleOnFocus ? this.menuVisibleOnFocus = !1 : this.visible = !this.visible, this.visible && (this.$refs.input || this.$refs.reference).focus());
    },
    selectOption() {
      this.visible ? this.options[this.hoverIndex] && this.handleOptionSelect(this.options[this.hoverIndex]) : this.toggleMenu();
    },
    deleteSelected(e) {
      e.stopPropagation();
      const t = this.multiple ? [] : "";
      this.$emit("input", t), this.emitChange(t), this.visible = !1, this.$emit("clear");
    },
    deleteTag(e, t) {
      const i = this.selected.indexOf(t);
      if (i > -1 && !this.selectDisabled) {
        const r = this.value.slice();
        r.splice(i, 1), this.$emit("input", r), this.emitChange(r), this.$emit("remove-tag", t.value);
      }
      e.stopPropagation();
    },
    onInputChange() {
      !this.isVirtualListMode && this.filterable && this.query !== this.selectedLabel && (this.query = this.selectedLabel, this.handleQueryChange(this.query));
    },
    onOptionDestroy(e) {
      e > -1 && (this.optionsCount--, this.filteredOptionsCount--, this.options.splice(e, 1));
    },
    resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize() {
      this.resetInputWidth(), this.multiple && this.resetInputHeight();
    },
    checkDefaultFirstOption() {
      this.hoverIndex = -1;
      let e = !1;
      for (let t = this.options.length - 1; t >= 0; t--)
        if (this.options[t].created) {
          e = !0, this.hoverIndex = t;
          break;
        }
      if (!e)
        for (let t = 0; t !== this.options.length; ++t) {
          const i = this.options[t];
          if (this.query) {
            if (!i.disabled && !i.groupDisabled && i.visible) {
              this.hoverIndex = t;
              break;
            }
          } else if (i.itemSelected) {
            this.hoverIndex = t;
            break;
          }
        }
    },
    getValueKey(e) {
      return Object.prototype.toString.call(e.value).toLowerCase() !== "[object object]" ? e.value : d(e.value, this.valueKey);
    }
  },
  created() {
    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder, this.multiple && !Array.isArray(this.value) && this.$emit("input", []), !this.multiple && Array.isArray(this.value) && this.$emit("input", ""), this.lazyLoad && (this.showLoadMoreBar = !0), this.debouncedOnInputChange = R(() => {
      this.onInputChange();
    }, this.debounce), this.debouncedQueryChange = R((e) => {
      this.handleQueryChange(e.target.value);
    }, this.debounce), this.eventOn("COMP_SELECT_OPTION_unBindObserve", this.unBindObserve), this.eventOn("COMP_SELECT_OPTION_loadFinished", this.loadFinished);
  },
  mounted() {
    this.multiple && Array.isArray(this.value) && this.value.length > 0 && (this.currentPlaceholder = "");
    const e = this.$refs.reference;
    if (e && e.$el) {
      const t = {
        medium: 36,
        small: 32,
        mini: 28
      }, i = e.$el.querySelector("input");
      this.initialInputHeight = i.getBoundingClientRect().height || t[this.selectSize];
    }
    this.remote && this.multiple && this.resetInputHeight(), this.$nextTick(() => {
      e && e.$el && (this.inputWidth = e.$el.getBoundingClientRect().width);
    }), this.setSelected();
  },
  beforeDestroy() {
    var e, t;
    this.io && ((t = (e = this.io).disconnect) == null || t.call(e));
  }
}, Be = {
  ref: "loadMoreBar",
  style: { height: "32px" }
}, ke = {
  key: 1,
  class: "el-select-dropdown__empty"
};
function $e(e, t, i, r, l, s) {
  const o = v("RIcon"), a = v("ElInput"), u = v("VirtualList"), p = v("Option"), w = v("Scrollbar2"), m = v("SelectMenu"), S = ee("clickoutside");
  return g((c(), I(
    "div",
    {
      class: O(["el-select r-select", [s.selectSize ? "el-select--" + s.selectSize : ""]]),
      style: k({ width: i.width }),
      onClick: t[7] || (t[7] = y((...h) => s.toggleMenu && s.toggleMenu(...h), ["stop"]))
    },
    [
      T(a, {
        ref: "reference",
        modelValue: l.selectedLabel,
        "onUpdate:modelValue": t[0] || (t[0] = (h) => l.selectedLabel = h),
        type: "text",
        placeholder: l.currentPlaceholder,
        name: i.name,
        id: i.id,
        autocomplete: i.autoComplete || i.autocomplete,
        size: s.selectSize,
        disabled: s.selectDisabled,
        readonly: s.readonly,
        "validate-event": !1,
        class: O({ "is-focus": l.visible, "r-input-text": i.type === "text" }),
        tabindex: i.multiple && i.filterable ? "-1" : null,
        onFocus: s.handleFocus,
        onBlur: s.handleBlur,
        onInput: e.debouncedOnInputChange,
        onKeydown: [
          t[1] || (t[1] = _(y((h) => s.handleNavigate("next"), ["stop", "prevent"]), ["native", "down"])),
          t[2] || (t[2] = _(y((h) => s.handleNavigate("prev"), ["stop", "prevent"]), ["native", "up"])),
          _(y(s.selectOption, ["prevent"]), ["native", "enter"]),
          t[3] || (t[3] = _(y((h) => l.visible = !1, ["stop", "prevent"]), ["native", "esc"])),
          t[4] || (t[4] = _((h) => l.visible = !1, ["native", "tab"]))
        ],
        onCompositionstart: s.handleComposition,
        onCompositionupdate: s.handleComposition,
        onCompositionend: s.handleComposition,
        onMouseenter: t[5] || (t[5] = (h) => l.inputHovering = !0),
        onMouseleave: t[6] || (t[6] = (h) => l.inputHovering = !1)
      }, te({
        suffix: b(() => [
          g(T(o, {
            class: O([
              "el-select__caret",
              "el-input__icon",
              "r-select-icon-arrow",
              "el-icon" + s.iconClass
            ]),
            name: "icon-caret_down",
            style: k({ color: s.selectDisabled ? "#C7D4D9" : "#141f21" })
          }, null, 8, ["class", "style"]), [
            [x, !s.showClose]
          ]),
          s.showClose ? (c(), E(o, {
            key: 0,
            class: "el-select__caret el-input__icon r-select-icon-clear",
            name: "icon-cuowu",
            style: { display: "inline-block", color: "#90a5ac", "font-size": "14px" }
          })) : D("v-if", !0)
        ]),
        _: 2
        /* DYNAMIC */
      }, [
        e.$slots.prefix ? {
          name: "prefix",
          fn: b(() => [
            C(e.$slots, "prefix")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "placeholder", "name", "id", "autocomplete", "size", "disabled", "readonly", "class", "tabindex", "onFocus", "onBlur", "onInput", "onKeydown", "onCompositionstart", "onCompositionupdate", "onCompositionend"]),
      T(ie, {
        name: "el-zoom-in-top",
        onBeforeEnter: s.handleMenuEnter,
        onAfterLeave: s.doDestroy,
        persisted: ""
      }, {
        default: b(() => [
          g(T(m, {
            ref: "popper",
            "append-to-body": i.popperAppendToBody
          }, {
            default: b(() => [
              s.isVirtualListMode ? (c(), E(u, {
                key: 0,
                ref: "VirtualListRef",
                data: s.filtedVirtualListData,
                itemHeight: i.virtualListItemHeight,
                wrapperHeight: i.virtualListWrapperHeight,
                wrapperClass: [
                  i.virtualListWrapperClass,
                  "r-select-virtual-list-box",
                  "el-select-dropdown__wrap"
                ]
              }, {
                option: b(({ optionData: h }) => [
                  C(e.$slots, "option", { optionData: h })
                ]),
                _: 3
                /* FORWARDED */
              }, 8, ["data", "itemHeight", "wrapperHeight", "wrapperClass"])) : g((c(), E(w, {
                key: 1,
                tag: "ul",
                "wrap-class": "el-select-dropdown__wrap",
                "view-class": "el-select-dropdown__list",
                ref: "scrollbar",
                native: !0,
                class: O({
                  "is-empty": !i.allowCreate && l.query && l.filteredOptionsCount === 0
                })
              }, {
                default: b(() => [
                  s.showNewOption ? (c(), E(p, {
                    key: 0,
                    value: l.query,
                    created: ""
                  }, null, 8, ["value"])) : D("v-if", !0),
                  C(e.$slots, "default"),
                  g(z(
                    "div",
                    Be,
                    null,
                    512
                    /* NEED_PATCH */
                  ), [
                    [x, l.showLoadMoreBar]
                  ])
                ]),
                _: 3
                /* FORWARDED */
              }, 8, ["class"])), [
                [x, l.options.length > 0 && !i.loading]
              ]),
              s.emptyText && (!i.allowCreate || i.loading || i.allowCreate && l.options.length === 0) ? (c(), I(
                se,
                { key: 2 },
                [
                  e.$slots.empty ? C(e.$slots, "empty", { key: 0 }) : (c(), I(
                    "p",
                    ke,
                    A(s.emptyText),
                    1
                    /* TEXT */
                  ))
                ],
                64
                /* STABLE_FRAGMENT */
              )) : D("v-if", !0)
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["append-to-body"]), [
            [x, l.visible && s.emptyText !== !1]
          ])
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["onBeforeEnter", "onAfterLeave"])
    ],
    6
    /* CLASS, STYLE */
  )), [
    [S, s.handleClose]
  ]);
}
const et = /* @__PURE__ */ F(De, [["render", $e], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/select/select.vue"]]);
export {
  et as R,
  Se as a
};
